import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuMusic2, LuClapperboard, LuGlobe, LuFileText, LuFileSpreadsheet } from "react-icons/lu";
import "./_assetPlaceholder.scss";

const TYPE_META = {
  audio: { Icon: LuMusic2, label: () => i18n.t("audio") || "Ses" },
  video: { Icon: LuClapperboard, label: () => i18n.t("video") || "Video" },
  html: { Icon: LuGlobe, label: () => "HTML" },
  csv: { Icon: LuFileSpreadsheet, label: () => "CSV" },
  pdf: { Icon: LuFileText, label: () => "PDF" },
  file: { Icon: LuFileText, label: () => i18n.t("file") || "Dosya" },
};

const AssetPlaceholder = ({ type, showLabel }) => {
  const meta = TYPE_META[type] || TYPE_META.file;
  const { Icon } = meta;
  return (
    <div className="cmp-placeholder">
      <span className="cmp-placeholder__badge">
        <Icon size={20} />
      </span>
      {showLabel ? <span className="cmp-placeholder__label">{meta.label()}</span> : null}
    </div>
  );
};

AssetPlaceholder.propTypes = {
  type: PropTypes.string,
  showLabel: PropTypes.bool,
};

AssetPlaceholder.defaultProps = {
  type: "file",
  showLabel: true,
};

export default AssetPlaceholder;
